import { render, staticRenderFns } from "./DeviceType.vue?vue&type=template&id=51a70948&scoped=true"
import script from "./DeviceType.vue?vue&type=script&lang=js"
export * from "./DeviceType.vue?vue&type=script&lang=js"
import style0 from "./DeviceType.vue?vue&type=style&index=0&id=51a70948&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51a70948",
  null
  
)

export default component.exports